<template>
  <div class="scheduled-task-manage">
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form" label-width="80px">
        <el-form-item label="任务名称">
          <el-input
            v-model="searchForm.keyword"
            placeholder="请输入任务名称/编码"
            clearable
            class="search-input"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        <el-form-item label="任务状态">
          <el-select v-model="searchForm.statusCode" placeholder="请选择" clearable class="search-select">
            <el-option label="暂停" value="PAUSED" />
            <el-option label="运行中" value="RUNNING" />
          </el-select>
        </el-form-item>
        <el-form-item label="最近结果">
          <el-select v-model="searchForm.lastResult" placeholder="全部" class="search-select">
            <el-option label="全部" value="" />
            <el-option label="成功" value="SUCCESS" />
            <el-option label="失败" value="FAILURE" />
          </el-select>
        </el-form-item>
        <el-form-item label-width="20px" label=" ">
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-table
      :data="taskList"
      v-loading="loading"
      border
      stripe
      class="task-table"
      height="100%"
    >
      <el-table-column type="index" label="序号" width="50" :index="indexMethod" align="center"/>
      <el-table-column prop="taskName" label="任务名称" min-width="160" show-overflow-tooltip />
      <el-table-column label="任务周期" min-width="190">
        <template slot-scope="{ row }">
          <div v-if="editingTaskId === row.taskId" class="cron-edit-cell">
            <el-input
              v-model="editingCronExpr"
              size="mini"
              placeholder="请输入cron表达式"
              class="cron-edit-input"
              @keyup.enter.native="saveCron(row)"
            />
            <el-tooltip content="保存" placement="top">
              <el-button
                type="primary"
                icon="el-icon-check"
                size="mini"
                circle
                :loading="cronSavingId === row.taskId"
                @click="saveCron(row)"
              />
            </el-tooltip>
            <el-tooltip content="取消" placement="top">
              <el-button icon="el-icon-close" size="mini" circle @click="cancelEditCron" />
            </el-tooltip>
          </div>
          <div v-else class="cron-display-cell">
            <div class="cron-readable">{{ cronReadableText(row.cronExpr) }}</div>
            <div class="cron-expression">
              <span>{{ row.cronExpr }}</span>
              <el-tooltip content="编辑任务周期" placement="top">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  class="cron-edit-button"
                  @click="startEditCron(row)"
                />
              </el-tooltip>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="任务描述" min-width="300" show-overflow-tooltip />
      <el-table-column prop="statusCode" label="任务状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.statusCode === 'RUNNING' ? 'success' : 'info'" size="small">
            {{ statusLabel(row.statusCode) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="lastRunAt" label="最近执行时间" width="150" align="center"/>
      <el-table-column prop="nextRunAt" label="下次执行时间" width="150" align="center"/>
      <el-table-column prop="lastResult" label="最近结果" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.lastResult" :type="row.lastResult === 'SUCCESS' ? 'success' : 'danger'" size="small">
            {{ resultLabel(row.lastResult) }}
          </el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="170" align="center">
        <template slot-scope="{ row }">
          <el-button
            v-if="row.statusCode !== 'RUNNING'"
            type="text"
            size="small"
            :loading="actionLoadingId === row.taskId"
            @click="handleStart(row)"
          >
            开启
          </el-button>
          <el-button
            v-else
            type="text"
            size="small"
            class="danger-text"
            :loading="actionLoadingId === row.taskId"
            @click="handlePause(row)"
          >
            暂停
          </el-button>
          <el-button type="text" size="small" @click="openRunLogs(row)">记录</el-button>
          <el-button
            type="text"
            size="small"
            :loading="runNowLoadingId === row.taskId"
            @click="handleRunNow(row)"
          >
            立即执行
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="runLogTitle"
      :visible.sync="runLogDialogVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <el-table :data="runLogs" v-loading="runLogLoading" border stripe max-height="700" min-height="500">
        <el-table-column type="index" label="序号" width="70" align="center" :index="runLogIndexMethod" />
        <el-table-column prop="startedAt" label="开始时间" width="170" />
        <el-table-column prop="finishedAt" label="结束时间" width="170" />
        <el-table-column prop="durationMs" label="耗时(ms)" width="110" align="center"/>
        <el-table-column prop="result" label="结果" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.result === 'SUCCESS' ? 'success' : row.result === 'FAILURE' ? 'danger' : 'info'" size="small">
              {{ resultLabel(row.result) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="errorMessage" label="错误信息" min-width="220" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.errorMessage || '-' }}</template>
        </el-table-column>
      </el-table>
      <div v-if="runLogTotal > runLogPageSize" class="run-log-pagination">
        <el-pagination
          small
          background
          layout="total, prev, pager, next"
          :total="runLogTotal"
          :page-size="runLogPageSize"
          :current-page="runLogCurrentPage"
          @current-change="handleRunLogPageChange"
        />
      </div>
    </el-dialog>

    <el-dialog
      title="立即执行"
      :visible.sync="runNowDialogVisible"
      width="420px"
      :close-on-click-modal="false"
    >
      <el-form label-width="90px">
        <el-form-item label="任务名称">
          <span>{{ runNowTask ? runNowTask.taskName : '-' }}</span>
        </el-form-item>
        <el-form-item label="报表日期">
          <el-date-picker
            v-model="runNowReportDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择报表日期"
            :picker-options="runNowDatePickerOptions"
            class="run-now-date-picker"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="runNowDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="runNowLoadingId === (runNowTask && runNowTask.taskId)" @click="submitRunNowWithDate">
          立即执行
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'ScheduledTaskManage',
  data() {
    return {
      searchForm: {
        keyword: '',
        statusCode: '',
        lastResult: ''
      },
      taskList: [],
      loading: false,
      actionLoadingId: '',
      runNowLoadingId: '',
      total: 0,
      currentPage: 1,
      pageSize: 10,
      editingTaskId: '',
      editingCronExpr: '',
      cronSavingId: '',
      runLogDialogVisible: false,
      runLogLoading: false,
      runLogTask: null,
      runLogs: [],
      runLogTotal: 0,
      runLogCurrentPage: 1,
      runLogPageSize: 10,
      runNowDialogVisible: false,
      runNowTask: null,
      runNowReportDate: this.formatClientDate(),
      runNowDatePickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(23, 59, 59, 999);
          return time.getTime() > today.getTime();
        }
      }
    };
  },
  computed: {
    runLogTitle() {
      const name = this.runLogTask && this.runLogTask.taskName ? this.runLogTask.taskName : '';
      return name ? `执行记录 - ${name}` : '执行记录';
    }
  },
  mounted() {
    this.loadTaskList();
  },
  methods: {
    async loadTaskList() {
      this.loading = true;
      try {
        const res = await api.post('/system/scheduled-task/list', {
          keyword: this.searchForm.keyword,
          statusCode: this.searchForm.statusCode,
          lastResult: this.searchForm.lastResult,
          page: this.currentPage,
          pageSize: this.pageSize
        });
        const payload = res.data && res.data.data ? res.data.data : {};
        this.taskList = Array.isArray(payload.list) ? payload.list : [];
        this.total = Number(payload.total) || 0;
      } catch (e) {
        this.taskList = [];
        this.total = 0;
        this.$message.error(e.response?.data?.message || '加载定时任务失败');
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.loadTaskList();
    },
    handleReset() {
      this.searchForm.keyword = '';
      this.searchForm.statusCode = '';
      this.searchForm.lastResult = '';
      this.currentPage = 1;
      this.loadTaskList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadTaskList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadTaskList();
    },
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    runLogIndexMethod(index) {
      return (this.runLogCurrentPage - 1) * this.runLogPageSize + index + 1;
    },
    formatClientDate(date = new Date()) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    isBaiduAdGroupReportTask(row) {
      return row && (row.taskCode === 'BAIDU_AD_GROUP_REPORT_SYNC' || row.taskName === '百度推广单元报表同步');
    },
    statusLabel(status) {
      const map = {
        PAUSED: '暂停',
        RUNNING: '运行中'
      };
      return map[status] || status || '-';
    },
    resultLabel(result) {
      const map = {
        SUCCESS: '成功',
        FAILURE: '失败',
        RUNNING: '执行中'
      };
      return map[result] || result || '-';
    },
    cronReadableText(expr) {
      let parts = String(expr || '').trim().split(/\s+/);
      if (parts.length === 6) {
        parts = parts.slice(1);
      }
      if (parts.length !== 5) return '自定义周期';
      const [minute, hour, dayOfMonth, month, dayOfWeek] = parts;
      if (minute === '*' && hour === '*' && dayOfMonth === '*' && month === '*' && dayOfWeek === '*') {
        return '每分钟执行';
      }
      if (/^\*\/\d+$/.test(minute) && hour === '*' && dayOfMonth === '*' && month === '*' && dayOfWeek === '*') {
        return `每 ${minute.slice(2)} 分钟执行`;
      }
      if (/^\d+$/.test(minute) && hour === '*' && dayOfMonth === '*' && month === '*' && dayOfWeek === '*') {
        return `每小时第 ${minute} 分钟执行`;
      }
      if (/^\d+$/.test(minute) && /^\d+$/.test(hour) && dayOfMonth === '*' && month === '*' && dayOfWeek === '*') {
        return `每天 ${this.padTime(hour)}:${this.padTime(minute)} 执行`;
      }
      if (/^\d+$/.test(minute) && /^\d+$/.test(hour) && /^\d+$/.test(dayOfMonth) && month === '*' && dayOfWeek === '*') {
        return `每月 ${dayOfMonth} 日 ${this.padTime(hour)}:${this.padTime(minute)} 执行`;
      }
      if (/^\d+$/.test(minute) && /^\d+$/.test(hour) && dayOfMonth === '*' && month === '*' && /^[0-7]$/.test(dayOfWeek)) {
        return `每周${this.weekdayText(dayOfWeek)} ${this.padTime(hour)}:${this.padTime(minute)} 执行`;
      }
      if (/^\d+$/.test(minute) && /^\d+$/.test(hour) && dayOfMonth === '*' && month === '*' && /^[0-7](,[0-7])+$/.test(dayOfWeek)) {
        const days = dayOfWeek.split(',').map((d) => this.weekdayText(d)).join('、');
        return `每周${days} ${this.padTime(hour)}:${this.padTime(minute)} 执行`;
      }
      return `自定义周期：${this.describeCronParts({ minute, hour, dayOfMonth, month, dayOfWeek })}`;
    },
    padTime(v) {
      return String(v).padStart(2, '0');
    },
    weekdayText(v) {
      const map = {
        0: '日',
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
        7: '日'
      };
      return map[String(v)] || v;
    },
    describeCronParts({ minute, hour, dayOfMonth, month, dayOfWeek }) {
      const dayText = dayOfMonth === '*' ? '每天' : `每月${dayOfMonth}日`;
      const monthText = month === '*' ? '' : `${month}月`;
      const weekText = dayOfWeek === '*' ? '' : `，星期${dayOfWeek}`;
      const hourText = hour === '*' ? '每小时' : `${this.padTime(hour)}点`;
      const minuteText = minute === '*' ? '每分钟' : `第${minute}分钟`;
      return `${monthText}${dayText}${weekText}${hourText}${minuteText}`;
    },
    startEditCron(row) {
      this.editingTaskId = row.taskId;
      this.editingCronExpr = row.cronExpr || '';
    },
    cancelEditCron() {
      this.editingTaskId = '';
      this.editingCronExpr = '';
    },
    async saveCron(row) {
      const cronExpr = String(this.editingCronExpr || '').trim();
      if (!cronExpr) {
        this.$message.error('请输入cron表达式');
        return;
      }
      this.cronSavingId = row.taskId;
      try {
        await api.post(`/system/scheduled-task/${row.taskId}/cron`, { cronExpr });
        this.$message.success('任务周期已更新');
        this.cancelEditCron();
        this.loadTaskList();
      } catch (e) {
        this.$message.error(e.response?.data?.message || '更新任务周期失败');
      } finally {
        this.cronSavingId = '';
      }
    },
    async handleStart(row) {
      try {
        await this.$confirm(`确认开启定时任务「${row.taskName}」吗？`, '提示', {
          type: 'warning',
          confirmButtonText: '开启',
          cancelButtonText: '取消'
        });
      } catch (e) {
        return;
      }
      this.actionLoadingId = row.taskId;
      try {
        await api.post(`/system/scheduled-task/${row.taskId}/start`, {});
        this.$message.success('定时任务已开启');
        this.loadTaskList();
      } catch (e) {
        this.$message.error(e.response?.data?.message || '开启定时任务失败');
      } finally {
        this.actionLoadingId = '';
      }
    },
    async handlePause(row) {
      try {
        await this.$confirm(`确认暂停定时任务「${row.taskName}」吗？`, '提示', {
          type: 'warning',
          confirmButtonText: '暂停',
          cancelButtonText: '取消'
        });
      } catch (e) {
        return;
      }
      this.actionLoadingId = row.taskId;
      try {
        await api.post(`/system/scheduled-task/${row.taskId}/pause`, {});
        this.$message.success('定时任务已暂停');
        this.loadTaskList();
      } catch (e) {
        this.$message.error(e.response?.data?.message || '暂停定时任务失败');
      } finally {
        this.actionLoadingId = '';
      }
    },
    async handleRunNow(row) {
      if (this.isBaiduAdGroupReportTask(row)) {
        this.runNowTask = row;
        this.runNowReportDate = this.formatClientDate();
        this.runNowDialogVisible = true;
        return;
      }
      try {
        await this.$confirm(`确认立即执行定时任务「${row.taskName}」吗？`, '提示', {
          type: 'warning',
          confirmButtonText: '立即执行',
          cancelButtonText: '取消'
        });
      } catch (e) {
        return;
      }
      this.runNowLoadingId = row.taskId;
      try {
        await api.post(`/system/scheduled-task/${row.taskId}/run-now`, {});
        this.$message.success('定时任务已执行');
        this.loadTaskList();
      } catch (e) {
        this.$message.error(e.response?.data?.message || '立即执行定时任务失败');
      } finally {
        this.runNowLoadingId = '';
      }
    },
    async submitRunNowWithDate() {
      const row = this.runNowTask;
      if (!row || !row.taskId) return;
      if (!this.runNowReportDate) {
        this.$message.error('请选择报表日期');
        return;
      }
      this.runNowLoadingId = row.taskId;
      try {
        await api.post(`/system/scheduled-task/${row.taskId}/run-now`, {
          reportDate: this.runNowReportDate
        });
        this.$message.success('定时任务已执行');
        this.runNowDialogVisible = false;
        this.loadTaskList();
      } catch (e) {
        this.$message.error(e.response?.data?.message || '立即执行定时任务失败');
      } finally {
        this.runNowLoadingId = '';
      }
    },
    openRunLogs(row) {
      this.runLogTask = row;
      this.runLogCurrentPage = 1;
      this.runLogDialogVisible = true;
      this.loadRunLogs();
    },
    handleRunLogPageChange(page) {
      this.runLogCurrentPage = page;
      this.loadRunLogs();
    },
    async loadRunLogs() {
      if (!this.runLogTask || !this.runLogTask.taskId) return;
      this.runLogLoading = true;
      try {
        const res = await api.post(`/system/scheduled-task/${this.runLogTask.taskId}/run-logs`, {
          page: this.runLogCurrentPage,
          pageSize: this.runLogPageSize
        });
        const payload = res.data && res.data.data ? res.data.data : {};
        this.runLogs = Array.isArray(payload.list) ? payload.list : [];
        this.runLogTotal = Number(payload.total) || 0;
      } catch (e) {
        this.runLogs = [];
        this.runLogTotal = 0;
        this.$message.error(e.response?.data?.message || '加载执行记录失败');
      } finally {
        this.runLogLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.scheduled-task-manage {
  padding: 24px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}

.search-card {
  margin-bottom: 16px;
  flex-shrink: 0;
}

.search-card >>> .el-card__body {
  padding: 18px 20px 0;
}

.search-form >>> .el-form-item {
  margin-bottom: 18px;
}

.search-input {
}

.search-select {
}

.task-table {
  flex: 1;
  min-height: 0;
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.run-log-pagination {
  padding-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.run-now-date-picker {
  width: 100%;
}

.danger-text {
  color: #f56c6c;
}

.cron-display-cell {
  min-height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.cron-readable {
  color: #303133;
  font-weight: 500;
  line-height: 20px;
}

.cron-expression {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.cron-edit-button {
  padding: 0;
}

.cron-edit-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
}

.cron-edit-input {
  width: 170px;
}
</style>
